import * as React from "react";
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap,
} from "@material-ui/core/styles/withStyles";
import { Switch, Route } from "react-router-dom";
import { Theme } from "@material-ui/core/styles";
import AppView from "~common/components/app-view/index";
import QueryList from "~common/components/query-fulfillment/query-list";
import * as request from "superagent";
import URLManager from "~common/lib/url-manager";

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  match: any;
}

type State = {
  status: "loading" | "ready";
};

class UserGroupFeatureReport extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: "ready",
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>
  ) {}

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;

    var criteriaSelector = {
      formType: "userGroupFeatureReportCriteria",
      form: "userGroupFeatureCriteria",
      modules: "users",
    };
    var resultsSelector = {
      formType: "userGroupFeatureReportResults",
      form: "userGroupFeatureResults",
      modules: "users",
    };

    return (
      <div className={classes.container}>
        <AppView history={this.props.history}>
          <QueryList
            suppressCriteriaView={false}
            criteriaFormSelector={criteriaSelector}
            resultsFormSelector={resultsSelector}
            queryUrl="/api/users/report/features/query"
            autoQuery={true}
            excludeFromClear={[]}
            // onCriteriaFormSelection={this.handleCriteriaFormSelection}
            supressSectionStatusIcon
            // onRowClick={this.handleRowClick}
            // actionsForItemRow={this.handleActionsForItemRow}
            alwaysExecuteOnSubmit={true}
            noResultsText="No Results Found"
            reserveRowActionSpace={true}
            pruneCriteriaForm={true}
            submitButtonText={"Search"}
          />
        </AppView>
      </div>
    );
  }
}

export default withStyles(styles)(UserGroupFeatureReport);
